import axios from 'axios'
import http from '@/requests/http'
import urlHelper from '@/config/url'

class Cti {
  static queueReset (baseUrl, params) {
    return axios.post(`${baseUrl}${urlHelper.queueReset}`, params)
  }
  static processDnd (baseUrl, params) {
    if (params.option === 1) {
      return axios.get(`${baseUrl}${urlHelper.dndOn}`, { params: { ...params } })
    } else {
      return axios.get(`${baseUrl}${urlHelper.dndOff}`, { params: { ...params } })
    }
  }
  static dial (baseUrl, params) {
    return axios.get(`${baseUrl}${urlHelper.dial}`, { params: { ...params } })
  }
  static blindTransfer (baseUrl, params) {
    return axios.get(`${baseUrl}${urlHelper.blindTransfer}`, { params: { ...params } })
  }
  static attendedTransfer (baseUrl, params) {
    return axios.get(`${baseUrl}${urlHelper.attendedTransfer}`, { params: { ...params } })
  }
  static transfer (baseUrl, params) {
    return axios.get(`${baseUrl}${urlHelper.transfer}`, { params: { ...params } })
  }
  static unTransfer (baseUrl, params) {
    return axios.get(`${baseUrl}${urlHelper.unTransfer}`, { params: { ...params } })
  }
  static checkTransfer (baseUrl, params) {
    return axios.get(`${baseUrl}${urlHelper.checkTransfer}`, { params: { ...params } })
  }
  static listen (baseUrl, params) {
    return axios.get(`${baseUrl}${urlHelper.listen}`, { params: { ...params } })
  }
  static whisper (baseUrl, params) {
    return axios.get(`${baseUrl}${urlHelper.whisper}`, { params: { ...params } })
  }
  static callTest (baseUrl, params) {
    return axios.get(`${baseUrl}${urlHelper.whisper}`, { params: { ...params } })
  }
  static showCall (params) {
    return http.post('cti/calls/show-call', params)
  }
  static history (params) {
    return http.post('cti/calls/history', params)
  }
  static showRecordingFile (params) {
    return http.post('cti/consultations/show-recording-file', params)
  }
  static showOneTouchRecordingFile (params) {
    return http.post('cti/consultations/show-one-touch-recording-file', params)
  }
  static answer (baseUrl, params) {
    return axios.get(`${baseUrl}${urlHelper.answer}`, { params: { ...params } })
  }
  static playSound (baseUrl, params) {
    return axios.get(`${baseUrl}${urlHelper.playSound}`, { params: { channel: params } })
  }
  static hangup (baseUrl, params) {
    return axios.get(`${baseUrl}${urlHelper.hangup}`, { params: { channel: params } })
  }
  static hangupWithChannel (baseUrl, params) {
    return axios.get(`${baseUrl}${urlHelper.hangupWithChannel}`, { params: { extension: params } })
  }
  static get (url, params) {
    return axios.get(url, { params: { ...params } })
  }
  static customDial (baseUrl, params) {
    return axios.get(`${baseUrl}${urlHelper.customDial}`, { params: { ...params } })
  }
  static hangupCustomDial (baseUrl, params) {
    return axios.get(`${baseUrl}${urlHelper.hangupCustomDial}`, { params: { ...params } })
  }
  static getChannel (baseUrl, params) {
    return axios.get(`${baseUrl}${urlHelper.getChannel}`, { params: { ...params } })
  }
  static saveExtensions (baseUrl, params) {
    return http.post('users/save-extensions', params)
    // return axios.get(`${baseUrl}${urlHelper.updateExtension}`, { params: { ...params } })
  }
  static oneTouchRecording (baseUrl, params) {
    return axios.get(`${baseUrl}${urlHelper.oneTouchRecording}`, { params: { ...params } })
  }
}

export default Cti
